"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var ListSubheader_1 = __importDefault(require("@mui/material/ListSubheader"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var sizing_1 = require("./sizing");
var Box_1 = __importDefault(require("@mui/system/Box"));
var DiscountPrice = __importStar(require("./A_DiscountPrice"));
var material_1 = require("@mui/material");
function Component(props) {
    return (Preact.h(ListSubheader_1.default, { sx: __assign({ justifyContent: 'space-between', alignItems: 'center', paddingY: (0, sizing_1.toPixels)(8), color: '#1F2937', lineHeight: '25px', marginBottom: '6px', position: 'relative', paddingTop: '16px', backgroundColor: 'transparent' }, props.sx) },
        Preact.h(Box_1.default, { sx: { display: 'flex', justifyContent: 'space-between' } },
            Preact.h(material_1.Typography, { variant: "h5", noWrap: true }, props.subheader),
            props.price && (Preact.h(Box_1.default, { display: "flex", flexDirection: "column" },
                Preact.h(Box_1.default, { display: "flex", justifyContent: "flex-end", alignItems: "baseline" },
                    props.price &&
                        props.originalPrice &&
                        props.price < props.originalPrice && (Preact.h(DiscountPrice.Component, { discount: props.originalPrice, sx: { marginRight: '8px' } })),
                    Preact.h(material_1.Typography, { variant: "h5" }, props.price)),
                props.savings && (Preact.h(material_1.Typography, { variant: "body2", textAlign: "right", color: "primary" }, props.savings))))),
        props.extraText ? (Preact.h(Box_1.default, { sx: { paddingTop: '8px' } },
            Preact.h(Chip_1.default, { label: props.extraText, size: "small" }))) : null));
}
exports.Component = Component;
